import useClientState from '@/state/useClientState';

/**
 * All state- and actions concerning useDialogStore. Refine with shallow or code-split to prevent useless rerenders.
 */
const useDialogStore = () => {
  const dialogData = useClientState((state) => state.actionDialog.dialogData);
  const dialogKey = useClientState((state) => state.actionDialog.dialogKey);
  const dialogActionOptions = useClientState((state) => state.actionDialog.dialogActionOptions);
  const showDialog = useClientState((state) => state.actionDialog.showDialog);

  return {
    dialogKey,
    dialogData,
    showDialog,
    dialogActionOptions,
  };
};
export default useDialogStore;
